import { IIconProps } from './add';

export const IcoArrowLeftFilled: React.FC<IIconProps> = ({ style, cy }) => (
  <svg
    width="6"
    height="8"
    viewBox="0 0 6 8"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    data-cy={`IcoArrowLeftFilled${cy}`}
    style={style}
  >
    <path
      d="M5.47003 7.06L2.4167 4L5.47003 0.94L4.53003 0L0.530029 4L4.53003 8L5.47003 7.06Z"
      fill="currentColor"
    />
  </svg>
);
